import { render } from "./BaseSwiper.vue?vue&type=template&id=67d7bd2a&scoped=true"
import script from "./BaseSwiper.vue?vue&type=script&lang=js"
export * from "./BaseSwiper.vue?vue&type=script&lang=js"

import "./BaseSwiper.vue?vue&type=style&index=0&id=67d7bd2a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d7bd2a"]])

export default __exports__